import React, { useState } from 'react';
import { Window } from '@progress/kendo-react-dialogs';
import { ITicketProps } from '../../../../../../types/Ticket/ITicket';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetTenantQuery } from '../../../../../../redux/api/BaseApi';
import { isMobile } from 'react-device-detect';
import { SvgIcon } from '@progress/kendo-react-common';
import * as svg from '@progress/kendo-svg-icons';

const PrintWindow: React.FC = () => {
    const { ticketId } = useParams();
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const { data: tenant } = useGetTenantQuery()
    const [stage, setStage] = useState(isMobile ? 'FULLSCREEN' : 'DEFAULT');

    const goBack = () => {
        navigate('/ticket/' + ticketId);
    }

    //Automatically print the iframe when it loads
    const onLoad = (e) => {
        console.warn('onLoad', e);
        e.target.contentWindow.focus();
        e.target.contentWindow.print();
    }

    return (
        <Window stage={stage} onStageChange={(e) => setStage(e.state)} modal={true} minimizeButton={() => null} className='dashboard cool-window' title={<><SvgIcon size='large' icon={svg.printIcon} className='mr-2' ></SvgIcon>Print </>} onClose={goBack} initialHeight={800} initialWidth={Math.min(1000, window.innerWidth)}>
            <iframe onLoad={onLoad} src={tenant.Tenant_Url + '/calls/CallHistoryPrint.aspx?Call_Id=' + ticketId.toString()} width="100%" height="100%" />
        </Window>
    );
};

export default PrintWindow;